// 导入 GSAP 库和 ScrollTrigger 插件
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// 注册 ScrollTrigger 插件，以便 GSAP 可以使用它
$(function () {
    // 注册 ScrollTrigger 插件
    gsap.registerPlugin(ScrollTrigger);
    // 美眼仪，使用方式
    // 创建一个 GSAP 时间轴动画，并绑定 ScrollTrigger
    let tl = gsap.timeline({
        scrollTrigger: {
            trigger: ".meiyan-use", // 触发器元素
            start: "top top",               // 触发器起始位置：元素顶部距离视口顶部 -50px 时触
            end: "100%",                    // 触发器结束位置：滚动到元素高度的 100% 时结束
            pin: true,                      // 固定触发器元素
            //markers: true,                   // 显示调试标记（用于开发阶段）
            scrub: true               // 动画与滚动速度同步
        }
    });

    // 在时间轴中添加动画
    tl.to(".meiyan-use .section-md .item2", {
        duration: 2,   // 动画持续时间：2 秒
        y: "-100%",     // 动画效果：垂直向上移动 100%
        delay: 0.5,     // 动画延迟：0.5 秒
        //opacity: 1,   // （注释掉的代码）可以设置透明度变化
        //stagger: 0.1, // （注释掉的代码）可以设置多个元素的交错动画
        //ease: "power3.inOut" // （注释掉的代码）可以设置动画的缓动效果
    });
    tl.to(".meiyan-use .section-fd .line-1", {
        duration: 2,
        width: "100%",
    }, "<");
    tl.to(".meiyan-use .section-fd .line-2", {
        duration: 2,
        width: "0%",
    }, "<");
    tl.to(".meiyan-use .section-fd .item-1 .image,.meiyan-use .section-fd .item-1 .block", {
        duration: 2,
        opacity: 0.5,
    }, "<");
    tl.to(".meiyan-use .section-fd .item-2 .image,.meiyan-use .section-fd .item-2 .block", {
        duration: 2,
        opacity: 1,
    }, "<");
    // 添加点击事件，切换显示状态
    // 点击事件
    $(".meiyan-use .section-fd .item-1").click(function () {
        // 平滑滚动到动画的结束位置
        window.scrollTo({
            top: tl.scrollTrigger.start, // 滚动到动画的结束位置
            behavior: "smooth" // 平滑滚动
        });
    });

    $(".meiyan-use .section-fd .item-2").click(function () {
        // 平滑滚动到动画的起始位置
        window.scrollTo({
            top: tl.scrollTrigger.end, // 滚动到动画的起始位置
            behavior: "smooth" // 平滑滚动
        });
    });


    // 定义断点（用于响应式设计）
    const BREAKPOINT = 992;
    const mobile = window.innerWidth <= BREAKPOINT ? true : false;

    // 监听窗口大小变化，更新断点变量
    $(window).resize(function () {
        mobile = window.innerWidth <= BREAKPOINT ? true : false;
    });

    let tm = gsap.timeline({
        scrollTrigger: {
            trigger: ".meiyan-temp", // 触发器元素
            start: mobile ? "top 69" : "top top",        // 触发器起始位置：元素顶部距离视口顶部 -50px 时触
            end: "100%",                    // 触发器结束位置：滚动到元素高度的 100% 时结束
            pin: true,                      // 固定触发器元素
            //markers: true,                   // 显示调试标记（用于开发阶段）
            scrub: true               // 动画与滚动速度同步
        }
    });
    tm.to(".meiyan-temp .section-md .item-1", {
        duration: 2,   // 动画持续时间：2 秒
        y: 0,     // 动画效果：垂直向上移动 100%
        delay: 0,     // 动画延迟：0.5 秒
        opacity: 1,   // （注释掉的代码）可以设置透明度变化
        //stagger: 0.1, // （注释掉的代码）可以设置多个元素的交错动画
        //ease: "power3.inOut" // （注释掉的代码）可以设置动画的缓动效果
    }).to(".meiyan-temp .section-md .item-2", {
        duration: 2,   // 动画持续时间：2 秒
        y: 0,     // 动画效果：垂直向上移动 100%
        delay: 0,     // 动画延迟：0.5 秒
        opacity: 1,   // （注释掉的代码）可以设置透明度变化
        //stagger: 0.1, // （注释掉的代码）可以设置多个元素的交错动画
        //ease: "power3.inOut" // （注释掉的代码）可以设置动画的缓动效果
    }).to(".meiyan-temp .section-md .item-3", {
        duration: 2,   // 动画持续时间：2 秒
        y: 0,     // 动画效果：垂直向上移动 100%
        delay: 0,     // 动画延迟：0.5 秒
        opacity: 1,   // （注释掉的代码）可以设置透明度变化
        //stagger: 0.1, // （注释掉的代码）可以设置多个元素的交错动画
        //ease: "power3.inOut" // （注释掉的代码）可以设置动画的缓动效果
    });
});